import { Component } from "@angular/core";

@Component({
    selector: "mdk-app-store-button",
    templateUrl: "./app-store-button.component.html",
    styleUrls: ['./app-store-button.component.scss'],
})
export class AppStoreButtonComponent {
    public readonly APP_STORE_URL = "https://apps.apple.com/us/app/modak-makers/id6444897051"
}